<template>
    <div class="w-screen h-screen relative">
     
            <div class="wrap h-full">
                <div class="mb-12">
                    <h1>Woordslang</h1>
                </div>

                <form @submit.prevent="handleSubmit" class="absolute center w-1/2 center m-auto u-border u-padding">
                    <h2>Aanmelden</h2>

                    <Notification v-if="form.error" :notification="form.error" status="error"/>

                    <div class="flex flex-col">
                        <div class="w-full">
                            <FieldInput
                                    :fieldId="formFields.email.name"
                                    :label="formFields.email.label"
                                    :value="formFields.email.value"
                                    :required="formFields.email.required"
                                    :name="formFields.email.name"
                                    :placeholder="formFields.email.placeholder"
                                    :type="formFields.email.type"
                                    :rule="formFields.email.rule"
                                    :module="module"
                                    :subform="subform"
                                    :error="formFields.email.error"
                                    :formError="form.error"
                            />

                        </div>
                        <div class="mt-12 w-full">
                            <FieldInput
                                    :fieldId="formFields.password.name"
                                    :label="formFields.password.label"
                                    :value="formFields.password.value"
                                    :required="formFields.password.required"
                                    :name="formFields.password.name"
                                    :placeholder="formFields.password.placeholder"
                                    :type="formFields.password.type"
                                    :rule="formFields.password.rule"
                                    :module="module"
                                    :subform="subform"
                                    :error="formFields.password.error"
                                    :formError="form.error"
                            />
                        </div>
                    </div>

                    <button class="c-button mt-12 px-12" type="submit">
                        Verzenden
                    </button>
                </form>

            </div>
  
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import {
    LOGIN
  } from '@/utils/graphql'

  import FieldInput from '@/components/forms/FieldInput'
  import Notification from '@/components/Notification'

  export default {
    name: 'AdminLogin',

    data () {
      return {
        module: 'admin',
        subform: 'login',
        skipUserQuery: true
      }
    },

    created () {
      if (this.isAuthenticated) {
        this.$router.push({ name: 'AdminDashboard' })
      }
    },

    methods: {
      handleSubmit () {
        this.setFormError(null)
        const module = this.module
        const subform = this.subform
        const form = this.form

        this.$store.dispatch('forms/validateForm', { module, subform })

        if (!form.isValid) {
          return
        }

        const variables = {
          email: form.fields.email.value,
          password: form.fields.password.value
        }

        this.$apollo.mutate({
          mutation: LOGIN,
          variables,
        }).then((result) => {
          const user = result.data.login

          if (!user.token) {
            this.setFormError('Incorrecte combinatie')
            this.$SmoothScroll(this.$el, 500)
            return
          }

          this.authenticateUser(user)
        }).catch((error) => {
          this.setFormError('Incorrecte combinatie')
          this.$SmoothScroll(this.$el, 500)
        })
      },

      authenticateUser (user) {
        this.$store.commit('admin/setAuthentication', { user })
        this.$router.push({ name: 'AdminDashboard' })
      },

      setFormError (error) {
        const module = this.module
        const subform = this.subform
        this.$store.commit('setFormError', { module, subform, error })
      }
    },

    computed: {
      ...mapState('admin', {
        isAuthenticated: state => state.currentUser.isAuthenticated,
        form: state => state.login.form,
        formFields: state => state.login.form.fields
      })
    },

    components: {
      FieldInput,
      Notification
    }
  }
</script>
